import React from "react";
import "./Footer.css";
import play from "../../assets/images/Google_Play_Store_badge_EN_1.png";
import apple from "../../assets/images/Group_165074.png";
import riso from "../../assets/images/Group_165071.png";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="ftr_container">
      <div className="ftr_hd_1">
        <div className="ftr_abt">
          <h3>Risoapp India Pvt Ltd</h3>
          <p>
            RisoApp is an AI-powered platform for education and career counseling, offering personalized guidance from school to professional life. Combining AI insights with expert support, RisoApp serves students, professionals, parents, and institutions.
          </p>
        </div>

        <div className="ftr_link_main">
  <div className="ftr_lnk">
    <a href="https://risoapp.com/about-us" target="_blank" rel="noopener noreferrer">About Riso</a>
    <a href="https://risoapp.com/services" target="_blank" rel="noopener noreferrer">Riso Services</a>
    <a href="https://risohire.com/" target="_blank" rel="noopener noreferrer">Work at Riso</a>
    <a href="https://risoapp.com/blogs" target="_blank" rel="noopener noreferrer">Blogs</a>
    <a href="https://risoapp.com/contact-us" target="_blank" rel="noopener noreferrer">Contact Us</a>
    <a href="https://risoapp.com/contact-us" target="_blank" rel="noopener noreferrer">Help & Support</a>
  </div>

  <div className="ftr_lnk1">
    <a href="https://risoapp.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
    <a href="https://risoapp.com/terms" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
    <a href="https://risoapp.com/faq" target="_blank" rel="noopener noreferrer">FAQ</a>
    <a href="https://risoapp.com/fraud" target="_blank" rel="noopener noreferrer">Fraud Alert</a>
    <a href="https://risoapp.com/trust" target="_blank" rel="noopener noreferrer">Trust & Safety</a>
    <a href="https://risoapp.com/report-issue" target="_blank" rel="noopener noreferrer">Report Issue</a>
  </div>
</div>



        <div className="ftr_lnk2">
          <div className="ftr_app">
            <img src={play} alt="Google Play Store" />
            <img src={apple} alt="Apple Store" />
          </div>

          <div className="ftr_follow_us">
            <img src={riso} alt="Riso Logo" className="logo_main" />
            <div className="ftr_follow_2">
              <h3>Follow us on social media</h3>
              <div className="ftr_icons">
                <i>
                  <a href="https://www.facebook.com/panindiajob.seeker/?viewas=100000686899395" target="_blank" rel="noopener noreferrer">
                    <FaFacebookF />
                  </a>
                </i>
                <i>
                  <a href="https://www.linkedin.com/company/risoapp/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedinIn />
                  </a>
                </i>
                <i>
                  <a href="https://x.com/app_riso" target="_blank" rel="noopener noreferrer">
                    <FaXTwitter />
                  </a>
                </i>
                <i>
                  <a href="https://www.instagram.com/contact.riso/" target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
                </i>
                <i>
                  <a href="https://www.youtube.com/channel/UCBVAGRFnPEt9PQ8DLWycOGg" target="_blank" rel="noopener noreferrer">
                    <FaYoutube />
                  </a>
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ftr_hd_2">
        <p>
          All trademarks are the property of their respective owners. All rights
          received © 2024 Risoapp India Pvt Ltd.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
